import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["loading"],
    _excluded2 = ["iconSize", "loading"],
    _excluded3 = ["children", "loading", "loadingVoiceOver", "iconSize"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Spinner from '../Spinner/Spinner';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden';
import { LoadingMaskMixin, LoadingMaskContentMixin, LoadingMaskSpinnerMixin } from '../../mixins/components/LoadingMaskMixin';
import { ICON_SIZES } from '../../constants/ICON';
export var StyledLoadingMask = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledLoadingMask",
  componentId: "c11n-8-64-0__sc-felv1f-0"
})(["", ""], LoadingMaskMixin);
export var StyledLoadingMaskContent = /*#__PURE__*/styled(
/*#__PURE__*/
// eslint-disable-next-line zillow/react/prop-types
React.forwardRef(function (_ref, ref) {
  var loading = _ref.loading,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, rest));
})).withConfig({
  displayName: "StyledLoadingMaskContent",
  componentId: "c11n-8-64-0__sc-felv1f-1"
})(["", ""], LoadingMaskContentMixin);
export var StyledLoadingMaskSpinner = /*#__PURE__*/styled(
/*#__PURE__*/
// eslint-disable-next-line zillow/react/prop-types
React.forwardRef(function (_ref2, ref) {
  var iconSize = _ref2.iconSize,
      loading = _ref2.loading,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, rest));
})).withConfig({
  displayName: "StyledLoadingMaskSpinner",
  componentId: "c11n-8-64-0__sc-felv1f-2"
})(["", ""], LoadingMaskSpinnerMixin);
/**
 * A container used for masking content while something is loading, submitting, processing, etc.
 *
 * The container uses an ARIA live region with the
 * [status role](https://www.w3.org/TR/wai-aria-1.1/#status). When `loading` is set to `true`, the
 * content will be masked visually and hidden from screen readers, and the `loadingVoiceOver` text
 * will be announced.
 *
 * @since 8.1.0
 */

var LoadingMask = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      loading = _ref3.loading,
      loadingVoiceOver = _ref3.loadingVoiceOver,
      iconSize = _ref3.iconSize,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(StyledLoadingMask, _extends({
    ref: ref
  }, rest), loading ? /*#__PURE__*/React.createElement(VisuallyHidden, null, loadingVoiceOver) : null, /*#__PURE__*/React.createElement(StyledLoadingMaskContent, {
    loading: loading,
    "aria-hidden": loading
  }, children), /*#__PURE__*/React.createElement(StyledLoadingMaskSpinner, {
    loading: loading,
    iconSize: iconSize
  }, /*#__PURE__*/React.createElement(Spinner, null)));
});
LoadingMask.displayName = 'LoadingMask';
LoadingMask.propTypes = {
  /**
   * The content to be masked.
   */
  children: PropTypes.node.isRequired,

  /**
   * The loading state of the container.
   */
  loading: PropTypes.bool,

  /**
   * The text that will be announced to screen readers using
   * [`VisuallyHidden`](#/More%20components?id=visuallyhidden).
   */
  loadingVoiceOver: PropTypes.string,

  /**
   * The size of the [`Spinner`](#spinner).
   */
  iconSize: PropTypes.oneOf(Object.keys(ICON_SIZES)),

  /**
   * The ARIA role, defaulting to [status](https://www.w3.org/TR/wai-aria-1.1/#status).
   */
  role: PropTypes.string
};
LoadingMask.defaultProps = {
  loading: true,
  loadingVoiceOver: 'Loading',
  iconSize: 'md',
  role: 'status'
};
export default LoadingMask;